import {H2} from '@quarks';

interface WorkdayHeaderTitleProps {
  title: string;
  subtitle?: string;
  titleSize?: 'large' | 'default';
}

export const WorkdayHeaderTitle = ({title, subtitle, titleSize = 'default'}: WorkdayHeaderTitleProps) => {
  return (
    <>
      <div className="flex flex-row items-center gap-2.5 w-full">
        {titleSize === 'large' ? (
          <H2 className="font-semibold leading-6">{title}</H2>
        ) : (
          <p className="text-[15px] font-semibold leading-4">{title}</p>
        )}
      </div>

      {subtitle && <p className="text-[13px] text-mapiq-black-500 leading-4">{subtitle}</p>}
    </>
  );
};
